<template>
  <div>
    <div class="common-header">
      <table>
        <tr>
          <td>赛事房间名称：</td>
          <td v-text="`${mttDetail.matchName}`"></td>
          <td>报名费：</td>
          <td v-text="`${mttDetail.registationFee / 100} USTD`"></td>
        </tr>
        <tr>
          <td>创建者：</td>
          <td v-text="`${mttDetail.creatorName}`"></td>
          <td>升盲时间：</td>
          <td v-text="`${mttDetail.updateBlindTime}`"></td>
        </tr>
        <tr>
          <td>比赛时间：</td>
          <td v-text="`${mttDetail.startTime}`"></td>
          <td>猎人赛：</td>
          <td>
            {{ mttDetail.isHuntsmanMatch === 1 ? '是' : '否' }}
          </td>
        </tr>
        <tr>
          <td>总奖池：</td>
          <td v-text="`${mttDetail.totalBonus / 100} USTD`"></td>
          <td>盲注类型：</td>
          <td v-text="`${mttDetail.blindType === 0 ? '普通盲注表' : '快速盲注表'}`"></td>
        </tr>
        <tr>
          <td>参赛人数：</td>
          <td v-text="`${mttDetail.participateNum} 人`"></td>
          <td>比赛人数上限：</td>
          <td v-text="`${mttDetail.upperLimitPlayers} 人`"></td>
          <td>总报名费 ：</td>
          <td v-text="`${mttDetail.totalRegistationFee / 100} USTD`"></td>
        </tr>
      </table>
    </div>
    <!--        <div class="common-header">-->
    <!--            <div class="common-header-right">-->
    <!--                <div class="common-header-block">-->
    <!--                    <el-input placeholder="输入玩家昵称或ID查询" v-model="searchVal" class="input-with-select">-->
    <!--                      <el-select style="width:145px" v-model="searchType" slot="prepend" placeholder="请选择">-->
    <!--                        <el-option label="根据昵称查询" value="1"></el-option>-->
    <!--                        <el-option label="根据ID查询" value="2"></el-option>-->
    <!--                      </el-select>-->
    <!--                      <el-button slot="append" icon="el-icon-search" @click="searchPlayer({page:1})"></el-button>-->
    <!--                    </el-input>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <div class="common-table">
      <el-table v-loading="loading" :data="player.list" row-key="id" height="100%">
        <el-table-column label="玩家ID" align="center" prop="userId" width="150" />
        <el-table-column label="玩家昵称" width="150" align="center" prop="userNickName" />
        <el-table-column label="排名" align="center" prop="rank" />
        <el-table-column label="重构次数" align="center" prop="rebuyTimes" />
        <el-table-column label="奖励" align="center" prop="reward">
          <template slot-scope="scope">
            {{ scope.row.reward | numberChip }}
          </template>
        </el-table-column>
        <el-table-column label="剩余积分" align="center" prop="residualIntegral">
          <template slot-scope="scope">
            {{ scope.row.residualIntegral | numberChip }}
          </template>
        </el-table-column>
        <el-table-column label="淘汰时的盲注" align="center" prop="eliminateBlindNote">
          <template slot-scope="scope">
            {{ scope.row.eliminateBlindNote | blindNoteNumber2 }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      class="common-el-pagination"
      layout="prev,pager,next,jumper"
      background
      :page-size="20"
      :pager-count="5"
      :total="player.totalPage"
      :current-page="currentPage"
      @current-change="searchPlayer({ page: $event })"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      date: null,
      searchVal: '',
      configInfo: {},
      currentPage: 1,
      searchType: '1',
      gameTypes: [
        {
          label: '全部状态',
          value: '0',
        },
        {
          label: '未开赛',
          value: '1',
        },
        {
          label: '已结束',
          value: '2',
        },
        {
          label: '进行中',
          value: '3',
        },
      ],
      gameStates: [
        {
          label: '全部条件',
          value: '0',
        },
        {
          label: '实物赛',
          value: '1',
        },
        {
          label: '积分赛',
          value: '2',
        },
      ],
    };
  },
  computed: {
    ...mapState('mtt', ['mtt', 'mttDetail', 'player']),
    userType() {
      return localStorage.getItem('authTypeCode');
    },
  },
  created() {
    this.gameDetail();
    this.searchPlayer({ page: 1 });
  },
  methods: {
    ...mapActions('mtt', ['mttDetailApi', 'mttPlayerLApi']),
    // 比赛详情
    gameDetail() {
      this.loading = true;
      //   this.centerDialogVisible = true;
      let params = {
        matchId: this.$route.query.matchId,
      };
      this.mttDetailApi(params).then(() => {
        this.loading = false;
        this.$message.success('获取成功');
      });
    },
    searchPlayer(obj = {}) {
      this.loading = true;
      let params;
      if (this.searchType == 1) {
        params = {
          matchId: this.$route.query.matchId,
          nickName: this.searchVal,
          size: 20,
        };
      } else {
        params = {
          matchId: this.$route.query.matchId,
          userId: this.searchVal,
          size: 20,
        };
      }
      Object.assign(params, obj);
      this.currentPage = params.page;
      this.mttPlayerLApi(params).then(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
:global(.el-icon-edit-outline) {
  color: $theme-color;
  cursor: pointer;
}
.common-header {
  td:first-of-type {
    text-align: right;
  }
  td:nth-of-type(3) {
    padding-left: 50px;
    text-align: right;
  }
}
</style>
